import React, {useEffect, useRef} from "react";
import Icon from "@Components/Icon";

const Modal = ({ title, children, onClose, footer, id }) => {
  const modalRef = useRef();

  useEffect(() => {
    const { Modal: ModalJS } = require("@ffw/randstad-local-orbit/js/components/modal")
    const ModalJSInit = new ModalJS(modalRef.current);
    ModalJSInit.openModal(false);

    let timer;

		const closingModal = () => {
			timer = setTimeout(() => {
				onClose();
			}, 350);
		};

    // Handle X button event.
    modalRef.current.addEventListener('modal-close', closingModal);

    return () => {
      ModalJSInit.closeModal(false);
      modalRef.current && modalRef.current.removeEventListener('modal-close', closingModal);
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <div className="modal" ref={modalRef} data-rs-modal={id}>
        <div className="modal__dialog bg-variant-brand-tertiary" role="dialog" aria-modal="true" aria-labelledby="#" data-rs-modal-dialog="">
          <div className="modal__header" data-rs-modal-header="">
            <h3 className="modal__title">{title}</h3>
            <button className="button--icon-only modal__close" data-rs-modal-close-trigger="" aria-label="close">
              <Icon icon='close' className='icon icon--inline hidden--from-l fill-brand--blue icon--alternative'/>
              <Icon icon='close-30' className='icon icon--l icon--inline hidden--until-l icon--alternative'/>
            </button>
          </div>
          <div className={`modal__main modal__main--overflow`} data-rs-modal-main="">{children}</div>
          {footer &&
          <div className={`modal__footer`} data-rs-modal-footer="">{footer}</div>}
        </div>
      </div>
    </>
  );
};

export default Modal;
